export default "__VITE_ASSET__e24c2752__"